<template>
  <div>
    <div class="card">
      <div class="card-header animated fadeInRightBig">
        <div class="card-title">
          Solicitação de vale-transporte
        </div>
      </div>
      <div class="card-body">
        <div class="row mb-3">
          <div class="col-md-6">
            <label><span class="required">*</span> Data</label>
            <date-time
              v-model="transportationRequest.dateSelected"
              format="YYYY-MM-DD"
              formatted="DD/MM/YYYY"
              output-format="YYYY-MM-DD"
              :no-button-now="true"
            >
              <input
                type="text"
                class="form-control"
                :value="transportationRequest.date"
              >
            </date-time>
          </div>
          <div class="col-md-2 mt-4">
            <button
              class="btn btn-info"
              @click="addDate"
            >
              Adicionar Data
            </button>
          </div>
        </div>
        <div class="row">
          <table class="table table-hover">
            <thead>
              <tr>
                <th scope="col">
                  Data
                </th>
                <th scope="col">
                  Ações
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(date, index) in transportationRequest.dates"
                :key="date"
              >
                <td>
                  {{ formatDate(date) }}
                </td>
                <td>
                  <button
                    type="button"
                    class="btn btn-crud delete"
                    data-tooltip="tooltip"
                    title="Excluir"
                    @click="destroy(index)"
                  >
                    <i class="far fa-trash-alt" />
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="block text-right mt-1">
          <router-link
            to="/transport_solicitations"
            class="btn btn-back"
          >
            <i class="fa fa-arrow-left" /> Voltar
          </router-link>
          <a
            class="btn btn-add ml-1"
            @click="save"
          >
            Salvar
            <i class="fa fa-save" />
          </a>
        </div>

        <div class="row">
          <div class="col-md-4">
            <p><span class="required">*</span> Campos Obrigatórios</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiErrorMessage } from '@/utils/apiError'

export default {
  data() {
    return {
      users: [],
      transportationRequest: {
        dateSelected: '',
        dates: [],
        // justification: '',
      },
    }
  },
  mounted() {
    const self = this

    const { id } = self.$route.params
    if (id) {
      self.getTransportationRequest(id)
    }
  },
  methods: {
    save() {
      const self = this

      const api = `${this.$store.state.api}transport_solicitations`

      const fd = self.makeFormData()
      if (!fd) return

      axios
        .post(api, fd)
        .then(response => {
          self.$message(
            'Sucesso',
            'Solicitação de vale-transporte realizada com sucesso',
            'success',
          )
          this.$router.push('/transport_solicitations')
        })
        .catch(error => {
          self.$message('Erro', apiErrorMessage(error), 'error')
        })
    },
    makeFormData() {
      const self = this
      console.log(' aa')
      console.log(self.transportationRequest)
      const fd = new FormData()

      fd.append('date', self.transportationRequest.dates)

      fd.append('_method', 'POST')

      return fd
    },
    getTransportationRequest(id) {
      const self = this
      const api = `${self.$store.state.api}transport_solicitations/${id}`

      axios
        .get(api)
        .then(response => {
          self.transportationRequest = response.data.data[0]
        })
        .catch(error => {
          self.errors = error.response.data
          self.$message(null, self.errors, 'error')
        })
    },
    addDate() {
      this.transportationRequest.dates.push(
        this.transportationRequest.dateSelected,
      )
    },
    destroy(index) {
      const self = this

      swal({
        title: 'Deseja deletar o registro?',
        text: 'Essa operação não pode ser desfeita',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#DD6B55',
        confirmButtonText: 'Sim, deletar!',
        showLoaderOnConfirm: true,
        buttons: {
          catch: {
            text: 'Não',
            value: 'cancel',
            className: 'btn-danger',
          },
          confirm: {
            text: 'Sim',
            value: 'confirm',
          },
        },
      }).then(value => {
        switch (value) {
          case 'cancel':
            swal('Cancelado', 'O registro não foi excluido!', 'info')
            break

          case 'confirm':
            self.transportationRequest.dates.splice(index, 1)
            swal('Sucesso', 'Registro excluído com sucesso!', 'success')

            break
        }
      })
    },
    formatDate(date) {
      return moment(date).format('DD/MM/YYYY')
    },
  },
}
</script>
